import cs from 'classnames';
import { Contract, FormInput } from 'components/molecules';
import { useFormikContractHelpers } from 'hooks';
import { FormEvent } from 'react';
import { IChildrenProp } from 'types/components/components.interface';
import { IContractInputWrapperProps } from '../wrapper/ContractInputWrapper';
import './ContractInputBase.scss';

export interface IContractInputBaseProps
  extends IChildrenProp,
    IContractInputWrapperProps {
  name: string;
  classNames?: string[];
  disabled?: boolean;
  placeholder?: string;
}

const ContractInputBase = ({
  children,
  classNames = [],
  disabled,
  placeholder,
  name,
  autoFocus,
  ...props
}: IContractInputBaseProps) => {
  const { displayMode } = useFormikContractHelpers();

  const inputContainerClasses = cs(['contract-input', ...classNames]);

  const onKeyDown = (event: FormEvent<HTMLTextAreaElement>) => {
    event.currentTarget.style.height = 'inherit';
    event.currentTarget.style.height = '0px';
    event.currentTarget.style.height = `${event.currentTarget.scrollHeight}px`;
  };

  return (
    <Contract.Input.Wrapper {...props}>
      <FormInput.Field
        name={name}
        onKeyDown={onKeyDown}
        displayMode={displayMode}
        disabled={disabled}
        autoFocus={autoFocus}
        className={inputContainerClasses}
        placeholder={placeholder}
      />
      {children}
    </Contract.Input.Wrapper>
  );
};

export default ContractInputBase;
